import { Fragment, useCallback, useEffect, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { __MUNICIPALITY_API_URL__ } from 'shell/constants/environment';
import FormForeignState, { ForeignStateForm } from 'system/geographic/components/state/form';
import { useHttpFetch } from 'shell/hooks/use-old-http-fetch';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonForeignStateCrumbs } from '../constants';
import { HttpResponse } from 'shell/models/http-response';
import { ForeignState } from 'shell/models/state';

const ForeignStateDetailPage = (): React.ReactElement => {
  const params = useParams();

  const {
    get: getForeignState,
    data,
    error,
    loading,
  } = useHttpFetch<HttpResponse<ForeignState>>(
    `${__MUNICIPALITY_API_URL__}/geo/stato/${params.id}`
  );

  useEffect(() => {
    getForeignState();
  }, []);

  const foreignState: ForeignStateForm = useMemo(() => {
    const foreignStatePayload = data?.payload;
    if (!foreignStatePayload || !!error) {
      return {};
    }
    return {
      acronym: foreignStatePayload.key.codice,
      code: foreignStatePayload.codIstat,
      name: foreignStatePayload.nome,
      exonym: foreignStatePayload.esonimo,
      endonym: foreignStatePayload.endonimo,
      citizenship: foreignStatePayload.codiceCittadinanza?.toString(),
      citizenMale: foreignStatePayload.nomeCittadino,
      citizenFemale: foreignStatePayload.nomeCittadina,
      fiscalCode: foreignStatePayload.belfiore,
      isoCode: foreignStatePayload.iso,
      capitalCode: foreignStatePayload.codiceCapitale?.toString(),
      capitalName: foreignStatePayload.nome,
      releaseUE: foreignStatePayload.flagRilascioCI === '1' ? true : false,
      ue: foreignStatePayload.flagUnioneEuropea,
      license: foreignStatePayload.siglaMotorizzazione,
    };
  }, [data, error]);

  const navigate = useNavigate();

  const onSubmit = useCallback(() => {
    return;
  }, []);

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonForeignStateCrumbs, { name: 'Dettaglio Stato Estero' }]} />
      {loading || error || !data ? undefined : (
        <FormForeignState
          title="Dettaglio Stato Estero"
          onOk={onSubmit}
          initialValues={foreignState}
          disabled
          onCancel={() => {
            navigate('/sistema/geografiche/estero/stato');
          }}
        />
      )}
    </Fragment>
  );
};

ForeignStateDetailPage.displayName = 'Foreign State Detail page component';

export default ForeignStateDetailPage;
